import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingFutureEvents } from "./RacingFutureEvents";
import { RacingFutureEventsData } from "./data";
let _;
let _localMocks;
let PageMethodsMock;
let RacingPageMethodsMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-legacy-integration/lib-esm/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    RacingPageMethodsMock = _localMocks.RacingPageMethodsMock;
}
export class RacingFutureEventsRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new RacingFutureEventsData({
                pageMethods: new PageMethodsMock(),
                racingPageMethods: new RacingPageMethodsMock()
            }, () => { });
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            //export data store to window for debug purposes
            window["RacingFutureEventsDATA"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingFutureEventsData(options.dataProvider, OpenRacingGame);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        return super.activate(React.createElement(RacingFutureEvents, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
}
window["RacingFutureEvents"] = RacingFutureEventsRoot;
broadcastBlockLoad("RacingFutureEvents");
//# sourceMappingURL=index.js.map